import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { defineComponent } from 'vue';

export const CommentEditor = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['defaultValue'],
    template: require('./comment-editor.html'),
    data() {
        const value$ = new Subject<string>();

        return {
            value: '',
            value$,
            change$: value$.pipe(
                distinctUntilChanged(),
                debounceTime(300),
            ),
        }
    },
    mounted() {
        this.subscribeTo(this.change$, value => {
            this.$emit('change', value);
        });
    },
    watch: {
        defaultValue: {
            handler(defaultValue: string) {
                this.value = defaultValue;
            },
            immediate: true,
        },
        value(value: string) {
            this.value$.next(value);
        },
    },
})
